import axios from "axios";

export const updateIotStatus = async (
    status,
    token
  ) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/iot_device/v1/update`,
        {
         status
        },
        config
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

export const getIotStatus = async (
    token
  ) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/iot_device/v1/get`,
       
        config
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };
  export const getIotDeviceData = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get("https://xlhezos8wj.execute-api.us-east-1.amazonaws.com/dev/v1/get-iot-devices", config);
    return response;
  } catch (error) {
    throw error;
  }
}
  export const singleUpdate = async (token,device_id,version) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.post("https://xlhezos8wj.execute-api.us-east-1.amazonaws.com/dev/v1/server-to-iot-mqtt-client?action=singular_update", {device_id,version},config);
    return response;
  } catch (error) {
    throw error;
  }
}


export const singleRestart = async (token, device_id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios.post(
      "https://xlhezos8wj.execute-api.us-east-1.amazonaws.com/dev/v1/server-to-iot-mqtt-client?action=singular_restart",
      {device_id}, // Request body
      config         // Headers
    );

    return response;
  } catch (error) {
    throw error;
  }
};


export const globalUpdate = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios.post(
      "https://xlhezos8wj.execute-api.us-east-1.amazonaws.com/dev/v1/server-to-iot-mqtt-client?action=global_update",
      {}, // empty body
      config
    );
    return response;
  } catch (error) {
    throw error;
  }
};
